import { useIntl } from "react-intl";

import FeatureGates from "@atlassian/feature-gate-js-client";

import BannerAlert, { BannerProps } from "@/components/wpl/banner-alert/src";
import { useLocalizedHref } from "@/libraries/web-framework";

export const ConfluencePageBanner = () => {
    const intl = useIntl();
    const showAiBanner = FeatureGates.checkGate(
        "wac-uip-butter-bar-confluence-gate"
    );

    const aiBannerMessages: BannerProps = {
        identifier: "ConfluenceSoftwarePageTemplate.atlassian-intelligence_exp",
        text: intl.formatMessage({
            id: "ConfluenceSoftwarePageTemplate.banner-alert.atlassian-intelligence_exp",
            defaultMessage:
                "Transform teamwork with Atlassian Intelligence - now available."
        }),
        linkText: intl.formatMessage({
            id: "ConfluenceSoftwarePageTemplate.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: useLocalizedHref("/software/artificial-intelligence"),
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Learn more",
            "data-label-english": "Learn more"
        }
    };

    const showTeamBanner = FeatureGates.getExperimentValue(
        "wac-fy24-team-24-banner-confluence",
        "ShowButterBar",
        false
    );
    const teamBannerMessages: BannerProps = {
        identifier: "ConfluenceSoftwarePageTemplate.team-24",
        text: intl.formatMessage({
            id: "ConfluenceSoftwarePageTemplate.banner-alert.text.team-24",
            defaultMessage:
                "Our annual conference is back in Las Vegas! Be the first to see our latest innovations. For a limited time only, save $1000 on your all-access pass."
        }),
        linkText: intl.formatMessage({
            id: "ConfluenceSoftwarePageTemplate.team-24.link-text",
            defaultMessage: "Register now"
        }),
        linkUrl:
            "https://events.atlassian.com/team?ref=Team_24&utm_source=marketing&utm_campaign=acquisition&utm_content=outreach&utm_medium=confluence_banner",
        dataEventProps: {
            "data-product-key": "confluence",
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": "Register now",
            "data-label-english": "Register now"
        }
    };

    return showAiBanner ? (
        <BannerAlert {...aiBannerMessages} />
    ) : showTeamBanner ? (
        <BannerAlert {...teamBannerMessages} />
    ) : null;
};
